import {HStack, Text} from '@chakra-ui/react';
import {useTranslation} from 'react-i18next';
import {useEstDansCadencier} from '@/hooks/cadencier/useEstDansCadencier';

/**
 * Tag « Cadencier » affiché à côté du code article partout où un article est affiché sauf Mon Cadencier
 * lorsque l'article fait partie du cadencier du client.
 *
 */
export const TagCadencier: React.FC<{code_article: string}> = ({
  code_article,
}) => {
  const {t} = useTranslation();
  const estDansCadencier = useEstDansCadencier();

  if (!estDansCadencier(code_article)) return null;

  return (
    <HStack
      bg='blue.sky_light'
      color='blue.main'
      fontSize='xs'
      fontWeight='500'
      py='2px'
      px='8px'
      borderRadius='6px'
    >
      <Text>{t('global.cadencier')}</Text>
    </HStack>
  );
};
